import React from "react";
import { CheckIcon } from "lucide-react";
import { audience } from "../data/salesCopy";
import { SectionHeader } from "./SectionHeader";
export function Audience() {
  return <section className="mx-auto max-w-6xl px-5 py-9 md:py-16" data-id="element-19" data-mp="6upso89frbdy">
      <SectionHeader eyebrow={audience.eyebrow} title={audience.title} data-id="element-20" data-mp="6w114ldtt7be" />
      <ul className="mt-5 grid grid-cols-2 gap-2 md:mt-10 md:gap-5" data-id="element-21" data-mp="1ulguvjh34u2">
        {audience.items.map(a => <li key={a.title} className="relative flex flex-col rounded-xl bg-card p-3 ring-1 ring-line md:flex-row md:gap-4 md:rounded-2xl md:p-6" data-id="element-22" data-mp="grm4amumsdmq">
            {a.isNew && <span className="absolute -top-2 right-2 rounded-md bg-pencil px-1.5 py-0.5 text-[10px] font-bold text-ink md:static md:order-last md:self-start md:text-xs" data-id="element-23" data-mp="plh37d55t7tx">
                NUEVO
              </span>}
            <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-chalk-soft text-chalk md:h-7 md:w-7" data-id="element-24" data-mp="zjwrz9gps509">
              <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-25" data-mp="uihafrdqwgmm" />
            </span>
            <div className="mt-2 md:mt-0 md:flex-1" data-id="element-26" data-mp="16f2mkk7btvbk">
              <h3 className="text-[13px] font-bold leading-snug md:text-lg" data-id="element-27" data-mp="1bd48dcw508qq">{a.title}</h3>
              <p className="mt-1 text-xs leading-relaxed text-muted md:text-base" data-id="element-28" data-mp="1gaw9mxio977l">{a.text}</p>
            </div>
          </li>)}
      </ul>
      <a href="#garantia" className="mt-4 inline-block text-sm font-semibold text-chalk underline-offset-4 hover:underline md:mt-8 md:text-base" data-id="element-29" data-mp="1kamwwr8zp57d">
        {audience.guaranteeLink}
      </a>
    </section>;
}